import { queryOptions } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from '@/api/client';
import { qk } from '@/api/queries';
import type { Website } from '@/api/types';

export type { Website };

export const websitesQuery = (organization?: string) =>
  queryOptions({
    queryKey: qk.websites({ organization }),
    queryFn: () => unwrap(api.GET('/admin/websites', { params: { query: { organization, size: 100 } } })),
    select: (p) => p.items as Website[],
  });

export const websiteQuery = (id: string) =>
  queryOptions({
    queryKey: qk.website(id),
    queryFn: async (): Promise<Website> => unwrap(api.GET('/admin/websites/{website_id}', { params: { path: { website_id: id } } })),
  });

export function createWebsite(organizationId: string, body: Schemas['WebsiteCreate']): Promise<Website> {
  return unwrap(api.POST('/admin/organizations/{org_id}/websites', { params: { path: { org_id: organizationId } }, body }));
}
